module.exports = __webpack_public_path__ + "static/media/caret-down.a545f7c0.svg";